import { useState } from 'react';
import { useCondoContext } from '@/features/auth/use-condo-context';
import { useMovimientosFondo } from '@/features/fondo-reserva/api';
import { MovimientosTable } from '@/features/fondo-reserva/movimientos-table';
import { PageContainer } from '@/components/common/page-container';
import { PageHeader } from '@/components/common/page-header';

export function MovimientosFondoRoute() {
  const { condoId } = useCondoContext();

  const [cursorStack, setCursorStack] = useState<string[]>([]);
  const currentCursor = cursorStack[cursorStack.length - 1];

  const { data, isLoading } = useMovimientosFondo(condoId, {
    cursor: currentCursor,
  });

  function handleNextPage() {
    if (data?.cursor) {
      setCursorStack((prev) => [...prev, data.cursor!]);
    }
  }

  function handlePrevPage() {
    setCursorStack((prev) => prev.slice(0, -1));
  }

  return (
    <PageContainer>
      <PageHeader
        eyebrow="Finanzas · Fondo de reserva"
        title="Historial de movimientos"
        subtitle="Todos los ingresos y egresos registrados en el fondo de reserva, en orden cronologico."
      />

      <MovimientosTable
        data={data?.items ?? []}
        isLoading={isLoading}
        cursor={data?.cursor}
        onNextPage={handleNextPage}
        onPrevPage={handlePrevPage}
        hasPrevPage={cursorStack.length > 0}
      />
    </PageContainer>
  );
}
